(ns storrito.editor.music-modal
  "The music modal (pure Replicant): search the Instagram catalog and
   add a song as a music sticker to the editor2 story. Routes between
   the search view (storrito.editor.music-modal.search) and, once a song
   is picked, the section-selection view
   (storrito.editor.music-modal.section). All interactive state lives in
   the store under `[:ui/modal :music]`; the impure `:music/*` action
   handlers live in ui.editor2.modal-music."
  (:require [storrito.editor.music-modal.search :as search]
            [storrito.editor.music-modal.section :as section]
            [storrito.ui.button :as button]))

(defn- need-to-connect
  []
  [:div.flex.flex-col.mt-4
   [:p.mb-4.font-medium
    "You need to connect an Instagram account"
    " to add this sticker to your stories."]
   [:div.flex.justify-between.mt-4
    (button/button-secondary
      {:on {:click [[:ui/modal-close]]}}
      "Cancel")
    (button/a-button-primary
      {:href (str "/ui/connect3/" (random-uuid))
       :target "_blank"}
      "Connect your Instagram Account")]])

(defn panel
  [state]
  (let [music (get-in state [:ui/modal :music])
        connected? (boolean (seq (get-in music [:instagram-data :instagram.users])))]
    [:div.flex.flex-col.w-full
     ;; The top margin keeps the right-aligned account dropdown clear of
     ;; the modal's close button in the corner:
     [:div.flex.items-center.justify-between.mt-6
      [:div.text-4xl
       [:span
        {:style {:fontFamily "Instagram Sans Condensed"
                 :color "#d300c5"}}
        [:i.fa-solid.fa-music.mr-2]
        "MUSIC"]]
      ;; The selected account scopes the whole catalog (search and
      ;; browse categories), so it sits in the header. Irrelevant in the
      ;; section picker, where the track is already chosen:
      (when (and connected?
                 (not (:selected music)))
        (search/account-select music))]
     (cond
       (not connected?)
       (need-to-connect)

       (:selected music)
       (section/panel state)

       :else
       (search/panel state))]))
